export default __webpack_public_path__ + "images/models/19d5d912af88bcc9857da661ce964c76.usdz";